// extracted by mini-css-extract-plugin
export var image = "Download-module--image--acehw";
export var list = "Download-module--list--WZ+wF";
export var list__item = "Download-module--list__item--4Hjty";
export var subtitle = "Download-module--subtitle--yniic";
export var wrapper = "Download-module--wrapper--J1xhi";